import { DocumentService } from 'src/app/services/document.service';
import { FrontendLoggerService } from 'src/app/services/frontend-logger.service';
import { GroupedDocument } from './document-details.models';

export interface DocumentOpenCallbacks {
  activated: (documentId: string) => void;
  opened: () => void;
}

export class DocumentDownloadCoordinator {
  constructor(
    private readonly documents: DocumentService,
    private readonly logger: FrontendLoggerService
  ) {}

  fileIcon(filename: string): string {
    switch (this.extension(filename)) {
      case 'pdf': return 'picture_as_pdf';
      case 'doc':
      case 'docx': return 'description';
      case 'xls':
      case 'xlsx':
      case 'csv': return 'table_chart';
      case 'ppt':
      case 'pptx': return 'slideshow';
      case 'txt': return 'note';
      case 'eml':
      case 'msg':
      case 'email': return 'mail';
      case 'md': return 'article';
      case 'json': return 'data_object';
      default: return 'insert_drive_file';
    }
  }

  iconClass(filename: string): string {
    switch (this.extension(filename)) {
      case 'pdf': return 'type-pdf';
      case 'doc':
      case 'docx': return 'type-docx';
      case 'xls':
      case 'xlsx': return 'type-xlsx';
      case 'csv': return 'type-csv';
      case 'ppt':
      case 'pptx': return 'type-pptx';
      case 'txt': return 'type-txt';
      case 'eml':
      case 'msg':
      case 'email': return 'type-email';
      default: return '';
    }
  }

  download(document: GroupedDocument, open: (url: string, id?: string) => void): void {
    if (!document?.id) {
      this.logger.error('[downloadDocument] No document id provided');
      return;
    }
    if (document.publicUrl) {
      open(document.publicUrl, document.id);
      return;
    }
    this.logger.info('[downloadDocument] Resolviendo publicUrl faltante para documento', document.id);
    this.documents.getDocumentPublicUrl(document.id).subscribe({
      next: (publicUrl) => {
        document.publicUrl = publicUrl;
        open(publicUrl, document.id);
      },
      error: (error) => this.logger.error('[downloadDocument] Error resolving publicUrl: ' + String(error))
    });
  }

  open(publicUrl: string, documentId: string | undefined, callbacks: DocumentOpenCallbacks): void {
    this.logger.info('[downloadDocument] publicUrl:', publicUrl);
    if (!publicUrl) {
      this.logger.error('[downloadDocument] No publicUrl provided');
      return;
    }
    if (documentId) {
      callbacks.activated(documentId);
    }
    try {
      const openedWindow = globalThis.open(publicUrl, '_blank', 'noopener,noreferrer');
      if (openedWindow) {
        callbacks.opened();
      } else {
        this.logger.error('[downloadDocument] window.open returned null (popup blocked?)');
      }
    } catch (error) {
      this.logger.error('[downloadDocument] Error opening publicUrl: ' + String(error));
    }
  }

  private extension(filename: string): string | undefined {
    return filename.split('.').pop()?.toLowerCase();
  }
}
